import React from "react";
import "./textInputWithPercentage.css";
import PercentageIcon from "./assets/percentageIcon.png";

const TextInputWithPercentage = ({
  label = "Category 1",
  percentage = "",
  description = "",
  onPercentageChange,
  onDescriptionChange,
  percentagePlaceholder = "25",
  descriptionPlaceholder = "Add description",
  maxValue = 100,
  ...props
}) => {
  return (
    <div className="specialty-input-container">
      {label && <label className="specialty-input-label">{label}</label>}
      <div className="specialty-input-box">
        {/* Top Section: Percentage Input */}
        <div className="specialty-top">
          <input
            type="number"
            className="specialty-percentage-input"
            value={percentage}
            onChange={(e) => onPercentageChange(e.target.value)}
            placeholder={percentagePlaceholder}
            max={maxValue}
            {...props}
          />
          <span className="percentage-symbol">
            <img
              src={PercentageIcon}
              style={{ height: "20px", width: "20px" }}
              alt="percentage"
            />
          </span>
        </div>
        {/* Divider (80% width) */}
        <hr className="specialty-divider" />
        {/* Bottom Section: Description Textarea */}
        <textarea
          className="specialty-description-textarea"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder={descriptionPlaceholder}
          {...props}
        />
      </div>
    </div>
  );
};

export default TextInputWithPercentage;
